const Talents = () => {
  return <p>Talents</p>
}

export default Talents
